/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon24Regular = forwardRef('UiMenuDots9Icon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.878 4.5a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M19.5 6.38a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M6.37 12.002a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M11.997 13.877a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M21.375 12.003a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M4.495 21.38a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M13.877 19.505a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M21.375 19.505a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M4.495 6.38a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" })));
});
